/** 네이버 검색광고 계정ID. nuxt.config.ts 의 공통 스크립트와 동일한 값 */
const NAVER_WCS_ACCOUNT_ID = "s_29913ae870"

/**
 * 네이버 전환추적 이벤트 타입
 * https://navercts.gitbook.io/guide/script_guide
 */
type NaverConversionType =
  | "view_product"
  | "add_to_cart"
  | "add_to_wishlist"
  | "begin_checkout"
  | "purchase"
  | "sign_up"
  | "lead"
  | "schedule"
  | "subscribe"
  | "view_content"
  | `custom${string}`

export default {
  sendLog: (eventName: string, params?: Record<string, any>) => {
    if (useRuntimeConfig().public.USE_MARKETING === "true") {
      try {
        const eventId = crypto.randomUUID()
        useGtag().gtag("event", eventName, params)
        // @ts-ignore
        fbq("track", eventName, params, { eventId })

        api.metaConversion(eventName, eventId, params)
      } catch (err) {
        console.error(err)
      }
    }
  },

  /**
   * 네이버 검색광고 전환 이벤트 전송.
   * 공통 스크립트(wcslog.js)는 nuxt.config.ts 의 head 에서 이미 로드된다.
   *
   * @param type 전환 이벤트 타입
   * @param params purchase 는 value(결제금액) 필수, 그 외는 선택
   */
  sendNaverConversion: (
    type: NaverConversionType,
    params?: { value?: number; items?: { id: string }[] },
  ) => {
    if (!import.meta.client) return
    if (useRuntimeConfig().public.USE_MARKETING !== "true") return

    try {
      const wcs = (window as any).wcs
      if (!wcs) return

      const wcs_add = (window as any).wcs_add || {}
      wcs_add["wa"] = NAVER_WCS_ACCOUNT_ID
      ;(window as any).wcs_add = wcs_add

      wcs.trans({ type, ...params })
    } catch (err) {
      console.error(err)
    }
  },
}
